// extracted by mini-css-extract-plugin
export default {"trending-products-div":"TrendingProduct_trending-products-div__nZhFH","trending-products-title":"TrendingProduct_trending-products-title__BAWOD"};